var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProxmox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    width: 300,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(137)",
    d: "m0 0h926l27 7 16 6 16 8 12 8 10 8 10 9 7 7 10 13 10 16 8 17 7 22 4 19v920l-7 29-8 21-10 18-12 16-14 15-15 12-15 9-16 8-21 7-22 5h-919l-30-7-21-8-18-10-12-9-10-9-15-15-10-14-8-14-6-13-7-21-4-18v-925l6-24 6-17 8-16 10-16 11-13 13-13 13-10 18-11 16-7 15-5z",
    fill: "#E77201"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(381,171)",
    d: "m0 0h22l19 5 13 7 9 7 10 9 7 7 7 8 13 14 7 8 13 14 7 8 14 15 11 12 9 10 22 24 7 8 12 13 1 4-7 7-7 8-9 10-12 13-7 8-9 10-14 15-18 20-12 13-7 8-13 14-7 8-9 10-9 9-14 9-14 6-13 3h-21l-17-4-17-8-11-9-2-2 1-4 9-9 7-8 12-13 7-8 14-15 7-8 12-13 11-12 9-10 12-13 7-8 14-15 9-11 1-4-16-17-7-8-13-14-7-8-12-13-13-14-7-8-11-12-9-10-15-16-9-10-9-11-4-4 1-4 14-10 14-7z",
    fill: "#FEFDFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(797,171)",
    d: "m0 0h22l16 4 16 8 11 8 3 4-7 8-9 10-7 8-13 14-7 8-13 14-7 8-13 14-7 8-15 16-11 12-9 11-14 15 1 4 27 30 12 13 11 12 7 8 33 36 9 10 7 8 14 15 11 13-2 4-14 10-15 7-15 4h-22l-19-5-14-7-10-8-18-18-7-8-11-12-27-30-12-13-7-8-33-36-7-8-11-12-5-6 1-4 10-10 7-8 10-11 1-2h2l2-4 10-10 7-8 18-20 24-26 7-8 13-14 7-8 14-15 7-7 15-10 15-6z",
    fill: "#FEFDFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(469,112)",
    d: "m0 0h15l14 3 12 5 12 8 13 12 15 16 22 24 9 10 7 8 9 9v2l5-1 4-4h2l2-4 15-16 10-11 7-8 22-24 6-7 11-9 14-8 14-4 6-1h16l17 4 16 8 12 9-3 5-8 8-7 8-9 10-13 14-1 2h-2l-2 4-16 17-11 12-7 8-13 14-1 2h-2l-2 4-15 16-7 8-14 15-18 20-14 15-9 10-5-1-14-14-7-8-11-12-10-11-7-8-13-14-7-8-15-16-9-10-7-8-12-13-10-11-7-8-14-15-11-12-9-10-7-8-3-3 2-4 10-7 16-8 11-3z",
    fill: "#FEFDFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,360)",
    d: "m0 0 5 1 6 7 5 5 16 17 7 8 12 13 11 12 7 8 12 13 9 10 12 13 7 8 12 13 9 10 12 13 7 8 9 10 7 8 12 13-2 4-10 8-15 7-9 3-6 1h-21l-15-4-15-8-13-11-15-16-10-11-7-8-14-15-12-13-9-11-4 1-10 10-7 8-11 12-9 10-12 13-7 8-9 10-7 7-10 7-14 7-15 4h-20l-13-3-14-6-10-7-5-4 1-5 14-14 7-8 12-13 7-8 11-12 12-13 11-12 7-8 9-10 7-7 7-8 18-20 12-13 11-12 7-8 9-10z",
    fill: "#FEFDFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(431,686)",
    d: "m0 0h58l10 4 5 4 5 8 1 4v60l-4 10-4 5-7 4-10 2h-49l-10-2-7-4-6-7-3-8v-58l4-11 4-5 9-5z",
    fill: "#FEFDFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(814,686)",
    d: "m0 0h58l10 4 6 5 4 8 1 3v60l-3 8-6 8-5 3-11 2h-49l-10-2-8-5-5-6-2-4-1-6v-54l2-8 3-6 5-5 7-4z",
    fill: "#FEFDFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(301,686)",
    d: "m0 0h73l10 4 7 7 3 6 1 5v26l-4 10-6 7-6 3h-3l2 5 13 19 3 4-1 3-5 1h-10l-8-3-9-9-11-17-2-1h-27l-3 15-4 6-8 7-5 2h-6v-93l2-5z",
    fill: "#FEFDFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(661,686)",
    d: "m0 0h19l11 4 5 4 7 11 9 21 2 5 2 1 2-6 12-25 6-8 5-4 9-3h21l5 3 2 7v90l-8-1-8-4-6-8-2-5-1-19-1-37h-2l-8 16-16 35-6 12-5 3-5-5-6-10-12-27-11-23-3-1-1 53-3 9-8 9-7 3h-6l-1-16v-49l1-30 4-4z",
    fill: "#FEFDFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(186,686)",
    d: "m0 0h73l10 4 7 8 3 7 1 10v22l-2 9-6 9-5 4-7 2h-56l-2 11-6 8-7 5-9 1-1-5v-84l1-8 2-2z",
    fill: "#FEFDFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(922,686)",
    d: "m0 0 10 1 10 6 16 17 6 7 14-14 7-8 7-6 7-3h7l13 5v4l-14 15-9 11-7 7-6 7 1 4 8 8 9 11 7 7 7 8 4 5-1 4-9 4-7 1-10-3-12-11-9-10-4-5v-2l-5 2-15 16-9 9-10 4-11-2-8-4 1-4 10-10 7-8 9-10 10-12-2-4-16-17-7-8-9-11-3-2 1-4z",
    fill: "#FEFDFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(539,686)",
    d: "m0 0 9 1 8 4 4 3v2l3 1 7 8 2 4 4 2 5 6 7-6 7-8 10-11 7-4 7-2 7 1 10 4-1 5-12 13-7 8-11 12-6 8 9 9 7 8 9 10 12 14-1 4-9 4h-12l-8-4-11-11-7-8-5-6-4 1-16 17-8 8-7 3h-12l-10-5 1-4 5-5 13-14 7-8 10-11 1-4-8-8-7-8-12-13-9-11v-4l9-4z",
    fill: "#FEFDFB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(615,863)",
    d: "m0 0h511l1 3-2 1-661 1h-392v-3l165-1z",
    fill: "#FEFAF8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(825,711)",
    d: "m0 0h37l6 1 1 11-1 38-21 1h-16l-12-1-1-1v-47z",
    fill: "#E77201"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(441,711)",
    d: "m0 0h38l6 1v49l-20 1h-13l-16-1-1-1v-47z",
    fill: "#E77201"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(368,973)",
    d: "m0 0h14l8 4 7 8 3 9v11l-3 9-6 7-7 4-11 1-9-3-8-7-3-6-1-5v-12l3-9 4-6 6-4z",
    fill: "#E77201"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(622,973)",
    d: "m0 0h20l9 3 7 8 3 8v14l-3 8-7 8-6 3h-23l-1-1v-50z",
    fill: "#E77201"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(422,966)",
    d: "m0 0 25 1 9 3 6 7 1 2v10l-4 7-7 6-3 2 8 11 11 14v2h-8l-8-9-12-16-10-2v27l-7 1-2-2v-62z",
    fill: "#FEFCFA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,965)",
    d: "m0 0 4 2 5 10 13 32 8 21-1 2-6-1-4-6-4-10-2-1h-27l-2 2-5 14-2 2h-5l-1-5 5-11 15-37 5-11z",
    fill: "#FEFCFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(205,711)",
    d: "m0 0h42l7 1v25l-2 3h-47l-1-1v-27z",
    fill: "#E77201"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(615,966)",
    d: "m0 0 29 1 11 4 8 7 4 6 2 7v17l-4 9-7 8-6 4-10 2-16 1h-12l-1-1v-64zm7 7-1 1v50l1 1h23l8-5 6-7 2-7v-14l-4-10-8-7-7-2z",
    fill: "#FEFCFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(370,966)",
    d: "m0 0h11l10 3 8 6 6 9 3 10v9l-2 9-5 9-8 7-7 3-7 1h-9l-10-3-8-6-4-5-4-11v-15l4-11 9-10 9-4zm-2 7-8 4-4 5-3 6-1 5v12l3 9 7 8 6 3 11 1 9-3 7-6 4-8 1-4v-11l-4-11-7-7-7-3z",
    fill: "#FEFCFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,967)",
    d: "m0 0h7l1 28 36 1v-29h8v64l-7 1-1-1v-29h-26l-10-1v30l-7 1-2-1v-63z",
    fill: "#FEFCF9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(155,967)",
    d: "m0 0h8l1 45 4 8 7 4 8 1 8-3 5-6 1-3 1-46h8l1 1v22l-1 22-2 7-5 7-6 4-10 2-12-1-8-5-5-5-3-7-1-7v-17z",
    fill: "#FEFCFA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561,966)",
    d: "m0 0h22l17 1v5l-1 1h-31v22l26 1v5l-1 1h-25l1 22 29 1 2 1v5l-18 1h-21l-1-1v-64z",
    fill: "#FEFCFA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,711)",
    d: "m0 0h40l9 1 1 3v12l-2 6h-48z",
    fill: "#E77201"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(517,966)",
    d: "m0 0h29l2 1-1 5-5 8-14 19-11 16-6 10h35l2 2-1 4h-48l1-6 12-17 12-16 12-18-35-1-1-1v-5z",
    fill: "#FEFCF9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(814,686)",
    d: "m0 0h58v1l-8 1 1 2h-3l-1 4 5 2 2 2v5l-2 1-11 1-26 1-10-2-1-6 7-4-1-4-6-2z",
    fill: "#FFF6F3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(431,686)",
    d: "m0 0h58v1l-5 1-4 4-2 1 9 6-1 5-7 1h-33l-9-2-1-4 9-5-4-4v-2l-10-1z",
    fill: "#FFF6F3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(216,967)",
    d: "m0 0h50l2 4-1 2-21 1v57l-7 1-2-2v-56l-20-1-1-1z",
    fill: "#FEFCFA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(712,967)",
    d: "m0 0h20l9 2 6 5 3 8-1 8-3 5-7 5-7 1 10 13 11 13 1 4-5-1-10-11-9-12-1-3-4-1h-9l-1 28h-4v-63zm4 3-1 2v27l2 1 15-1 9-4 4-7v-8l-4-6-6-3-5-1z",
    fill: "#FEFBF9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1069,967)",
    d: "m0 0h21l9 2 6 5 2 4v12l-7 8-7 3h-3l7 10 10 11 5 7v2l-5-1-12-14-9-12-12-1-1 28h-4l-1-40zm5 3-1 1v28h17l8-4 5-6v-10l-5-6-4-2-6-1z",
    fill: "#FEFAF8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(869,967)",
    d: "m0 0h38l-1 4h-32v25l28 1v3h-28v27l34 1-1 3h-37l-1-1z",
    fill: "#FEF6F3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1016,967)",
    d: "m0 0h38v3l-34 1v25l28 1v3h-28l1 27 33 1v3h-38l-1-24v-39z",
    fill: "#FEFBF8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(431,972)",
    d: "m0 0 13 1 8 3 3 4 1 7-3 6-5 4-2 1h-16l-1-1v-23z",
    fill: "#E77201"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(767,967)",
    d: "m0 0h38v3l-11 1h-22l-1 25 28 1v3h-28l1 27 33 1v3h-38l-1-12v-51z",
    fill: "#FEFCF9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(834,966)",
    d: "m0 0 10 1 7 4 1 4-5-1-7-3h-9l-6 3-2 4v9l5 5 18 8 7 6 1 2v10l-5 8-5 4-7 2h-9l-9-3v-2l-3-1-1-5 5 2 4 3 3 1h13l7-6 2-5-1-7-5-5-11-5-9-4-5-5-1-9 3-8 6-5z",
    fill: "#FEFBF9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(479,967)",
    d: "m0 0h8v64h-8z",
    fill: "#FEFCFA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(619,686)",
    d: "m0 0 7 1 10 4-1 5-12 13-4 4h-10l-3-2v-7l3-6 5-4 4-2v-3l-4-2z",
    fill: "#FEF6F3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,977)",
    d: "m0 0h2l10 28v3h-24l1-6 8-20z",
    fill: "#E77201"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(923,967)",
    d: "m0 0 4 1 1 59 29 1v3h-34l-1-6v-57z",
    fill: "#FEFBF9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(970,967)",
    d: "m0 0 3 1 1 38v21l30 1-1 3h-33l-1-1-1-61z",
    fill: "#FEF6F3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(198,967)",
    d: "m0 0h8l1 1v22l-1 22h-1l-1-10-4-4-1 14h-1z",
    fill: "#FEF6F3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1069,967)",
    d: "m0 0h21l9 2 6 5 2 4v12l-7 8-7 3-3-1v-2l8-4 4-5v-10l-4-5-4-2-6-1h-14l-3 4-2-1z",
    fill: "#FEFBF9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(725,967)",
    d: "m0 0 13 1 6 3 4 5 2 6-1 8-3 5-7 5-7 1v-3l9-3 2-4 1-3v-8l-3-5-6-3-5-1-14-1v-1l9-1z",
    fill: "#FEFAF8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(870,1008)",
    d: "m0 0h3v19l35 1-1 3h-37z",
    fill: "#FEFDFB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,686)",
    d: "m0 0h21v1l-8 1-1 2h-2l3 5 2 2v6l-3 2-4-1-5-5 1-4 2-4-6-4z",
    fill: "#FFF6F3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(869,967)",
    d: "m0 0h38l-1 4h-33v3l-4-2z",
    fill: "#FEF9F6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(328,967)",
    d: "m0 0h2v62h-1l-1-38-2-1v-2h-2v-9l4-5z",
    fill: "#FFF6F3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(922,968)",
    d: "m0 0 2 1 1 9v22l-1 10v9l-1 6h-1z",
    fill: "#FFF6F3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(972,1023)",
    d: "m0 0 1 4 31 1-1 3h-33l-1-3z",
    fill: "#FEF9F6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(244,967)",
    d: "m0 0h22l2 4-1 2-21 1 1-2 6-3-9-1z",
    fill: "#FEF6F3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(834,966)",
    d: "m0 0 10 1 7 4 1 4-5-1-7-3h-9l-7 3 2-6z",
    fill: "#FEF9F6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(773,549)",
    d: "m0 0 2 1-2 4-10 8-15 7-9 3-6 1h-21l-5-1v-1h25l12-3 12-5 7-4h2v-2l6-4z",
    fill: "#FFF6F3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1070,973)",
    d: "m0 0h3v26l-1-2h-2l-1 2-1-8 1-17z",
    fill: "#FFF6F3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(481,122)",
    d: "m0 0 9 1 12 5 6 4v2l5 2 3 2v2l-4-1v-2l-4-1-13-8-11-3-8-1v-1z",
    fill: "#FFF6F3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,691)",
    d: "m0 0 3 1 3 5 5 3 1 4-5 1-8-7v-6z",
    fill: "#FFF6F3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(628,690)",
    d: "m0 0h6l2 1v3l-5 3-2 2-6-3-1-5z",
    fill: "#FEFDFB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(322,967)",
    d: "m0 0h6l1 1v6l-4 5-1 9h-1z",
    fill: "#FEFDFB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(997,697)",
    d: "m0 0 5 2 1 3-3 3-2 1h-6v-6h2v-2z",
    fill: "#FFF6F3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(744,978)",
    d: "m0 0 3 2-1 9-2 4 2 2-7 5-7 1v-3l9-3 2-4 1-3z",
    fill: "#FEF6F3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(938,1028)",
    d: "m0 0h19v3h-25v-1z",
    fill: "#FEF9F6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,695)",
    d: "m0 0 5 1 6 3 1 6-1 4-9-10z",
    fill: "#FFF6F3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(879,1028)",
    d: "m0 0h29l-1 3h-22v-1l-6-1z",
    fill: "#FEF7F5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(466,123)",
    d: "m0 0h9l-3 2-13 3-9 5-3-1 2-3z",
    fill: "#FFF6F3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(788,1028)",
    d: "m0 0h17v3h-24v-1z",
    fill: "#FEF8F6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,967)",
    d: "m0 0h1v5l-1 1h-31l4-2h25z",
    fill: "#FFF6F3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1087 1e3)",
    d: "m0 0h3l6 10-2 3-7-8z",
    fill: "#FEF9F6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(889,997)",
    d: "m0 0h13v3h-18l1-2z",
    fill: "#FEF8F5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(794,997)",
    d: "m0 0h5v3h-28l3-2h17z",
    fill: "#FEF7F4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(972,1023)",
    d: "m0 0 1 4 10 1-2 2-11 1-1-3z",
    fill: "#FEFCFA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(747,979)",
    d: "m0 0 3 3-1 8-3 4-3-1 3-7z",
    fill: "#FEFCFA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(543,697)",
    d: "m0 0 4 1 4 4v3l-5-1-4-4z",
    fill: "#FFF6F3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(869,967)",
    d: "m0 0 13 1v1l-8 2-1 3-4-2z",
    fill: "#FEFDFB"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(629,970)",
    d: "m0 0 10 1 2 2h-19l3-2z",
    fill: "#FFF6F3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1069,979)",
    d: "m0 0h3v12l-3-3z",
    fill: "#FEFEFC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(733,1009)",
    d: "m0 0 3 1v3l4 2v3l3 1-1 3-9-11z",
    fill: "#FFF6F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProxmox);
export default __webpack_public_path__ + "static/media/proxmox.f806443c236e1fd7c226304039f93fba.svg";
export { ForwardRef as ReactComponent };